import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton, InputText, InputDatePicker, InputTypeAhead } from "@loanbossinc/component-library";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;

const ContentWrapper = styled.div`
  display:flex;
  flex-direction: column;
`;

const DataWrapperRow = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  margin=bottom:10px;
`;

export default function AddEditHolidayModal({ title, isOpen, onClose, onAccept, countryCodes, holiday, isEdit, onreset }) {
  const [holidayItem, setHolidayItem] = useState(null);
  const [disableAccept, setDisableAccept] = useState(true);

  useEffect(() => {
    setHolidayItem(holiday);
  }, [holiday]);

  useEffect(() => {
    const validation = isEdit ||
      (!isEdit &&
        holidayItem &&
        holidayItem.cityId &&
        holidayItem.date &&
        holidayItem.holidayName !== "" &&
        holidayItem.observed);
    setDisableAccept(!validation);
  }, [holidayItem]);

  const handleChange = (name, value) => {
    setHolidayItem({
      ...holidayItem, // spreading the unchanged holidayItem
      [name]: value // changing the state of *changed holidayItem*
    });
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <StyledDialogIconButton onClick={onClose}>
        <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
      </StyledDialogIconButton>
      <StyledDialogContent>
        <ContentWrapper>
          {holidayItem &&
            <>
              <DataWrapperRow>
                <InputTypeAhead
                  id="holidayItem.cityId"
                  name="holidayItem.cityId"
                  value={holidayItem.cityId}
                  label="Country"
                  options={countryCodes}
                  displayWith={option => option && option.name}
                  setValueWith={option => option && option.id}
                  onChange={e => handleChange("cityId", e)}
                  variant="filled"
                  className="input"
                  style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }}
                  disabled={isEdit}
                />

                <InputText
                  placeholder="Value"
                  label={"Holiday Name"}
                  name="holidayName"
                  variant="filled"
                  onChange={e => handleChange(e.target.name, e.target.value)}
                  style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }}
                  value={holidayItem.holidayName}
                  disabled={isEdit}
                />
              </DataWrapperRow>
              <DataWrapperRow>
                <TextField
                  placeholder="Value"
                  label={"Holiday Date"}
                  name="date"
                  type="date"
                  defaultValue={holidayItem.date}
                  variant="filled"
                  onChange={e => handleChange("date", e.target.value)}
                  value={holidayItem.date}
                  style={{ width: "190px", marginLeft: "5px", marginRight: "5px", marginTop: "10px", backgroundColor: "#e7e7e7", paddingLeft: "10px" }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  disabled={isEdit}
                />
                <TextField
                  placeholder="Value"
                  label={"Holiday Observation Date"}
                  name="observed"
                  type="date"
                  defaultValue={holidayItem.observed}
                  variant="filled"
                  onChange={e => handleChange("observed", e.target.value)}
                  value={holidayItem.observed}
                  style={{ width: "190px", marginLeft: "5px", marginRight: "5px", marginTop: "10px", backgroundColor: "#e7e7e7" }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </DataWrapperRow>
            </>}
        </ContentWrapper>
      </StyledDialogContent>
      <DialogActions>
        {onClose && holidayItem && !holidayItem.manualEntry && <SecondaryButton size={"sm"} onClick={onreset} label="Reset" style={{ "margin-right": "16px" }} />}
        {onClose && holidayItem && holidayItem.manualEntry && <SecondaryButton size={"sm"} onClick={onClose} label="Cancel" style={{ "margin-right": "16px" }} />}
        <PrimaryButton disabled={disableAccept} size={"sm"} onClick={() => onAccept(holidayItem)} label="Save" />
      </DialogActions>
    </Dialog>
  );
}
